import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


export default function footer(props) {
  const { setTerm, setPolicy, isDark } = props;
  const dateNow = new Date();
  const year = dateNow && dateNow.getFullYear();
  const contactNumber = (<>
  <i className="fas fa-phone phone-icon"></i> 
  <a href="tel:1300262047" className="footer-link with-icon">
    {"1300 262 047"}
  </a>
 </>);
  const paymentAssistance = (
  <a 
    target="_blank" 
    href="https://files.superloop.com/terms/Superloop-Payment-Assistance-Policy.pdf" 
    className="footer-link"
  >
    {"Payment Assistance Policy"}
  </a>);
  const complaintsHandling = (<a 
    target="_blank" 
    href="https://files.superloop.com/terms/SL-Residential-Complaints-Handling.pdf" 
    className="footer-link"
  >
    {"Complaints Handling Policy"}
  </a>);
   const privacyComponent = (<a 
    href="https://files.superloop.com/terms/SL-Residential-privacy-policy.pdf"
    target="_blank" 
    className="footer-link"
  >
     {"Privacy Policy"}
  </a>);
  const termComponent = (<a href="/terms" target="_blank" className="footer-link">
    {"Terms & Conditions"}
  </a>);
  const eSafetyComponent = (<a href="/esafety" target="_blank" className="footer-link">{"eSafety"}</a>);
  const criticalComponent = (<a href="" target="_blank" className="footer-link">{"Critical Information Summary"}</a>);

  return (<>
    <div className={isDark ? "vw-footer-dark" : "vw-footer"}>
      <Container fluid>
        <Row>
          <Col className="footer-col">
            {`© University of Tasmania ${year}. All Rights Reserved `}  {" | "} {termComponent} {" | "} {privacyComponent} <br/>
            {eSafetyComponent} {" | "} {criticalComponent} {" | "}  {paymentAssistance} {" | "}  {complaintsHandling} <br/>
            {contactNumber}
          </Col>
        </Row>
      </Container>
    </div>
    <div className={isDark ? "vw-footer-mobile-dark" : "vw-footer-mobile"}>
      <Container fluid>
        <Row>
          <Col className="footer-col">
            {`© University of Tasmania ${year}. All Rights Reserved`}<br/>
            {termComponent} {" | "} {eSafetyComponent} {" | "} {privacyComponent} <br/>
            {criticalComponent} {" | "} {paymentAssistance} {" | "}  {complaintsHandling} <br/>
            {contactNumber}
          </Col>
        </Row>
      </Container>
    </div>
  </>);
}
